import axios from 'axios';
import VueAxios from 'vue-axios';

// TODO: Modificar URL cuando se utilice axios para llamar APIs
axios.defaults.baseURL = (process.env.NODE_ENV === 'production') ? 'https://api.cat4mro.com' : 'http://localhost:8081';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default ({ Vue }) => {
  Vue.use(VueAxios, axios);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-axios.js